var React = require('react');

function StreamlineLine37MusicNote1 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},[React.createElement("path",{"d":"M9.5 20.5c0 1.5-1.343 3-3 3-1.656 0-3-1.343-3-3 0-1.656 1.344-3 3-3h3v3zM20.5 16.5c0 1.5-1.343 3-3 3-1.656 0-3-1.343-3-3 0-1.656 1.344-3 3-3h3v3z","key":0}),React.createElement("path",{"d":"M9.5 17.5v-12l11-4.5v12.5M9.5 9l11-4.5","key":1})]),React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":1})]);
}

StreamlineLine37MusicNote1.displayName = "StreamlineLine37MusicNote1";

StreamlineLine37MusicNote1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine37MusicNote1;

StreamlineLine37MusicNote1.default = StreamlineLine37MusicNote1;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-37-music-note-1.svg
// module id = 773
// module chunks = 0